
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/[name]",
      function () {
        return require("private-next-pages/tag/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tag/[name]"])
      });
    }
  